import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';

const lciBoxImageOutline = (options: ShapeProps['options']): ShapeProps => ({
  shapeName: 'ellipse',
  options: {
    h: 0.62,
    w: 0.62,
    x: 7.59,
    y: 2.92,
    line: {
      color: theme.colors.inmarketGreen,
      width: 1,
    },
    ...options,
  },
});

const lciBoxRectangle = (options: ShapeProps['options']): ShapeProps => ({
  shapeName: 'rect',
  options: {
    fill: {
      color: theme.colors.darkGray,
      type: 'solid',
      ...options.fill,
    },
    h: 5.28,
    w: 5.84,
    x: 6.8,
    y: 1.11,
    ...options,
  },
});

export const shapes: ShapeProps[] = [
  lciBoxRectangle({
    fill: { color: theme.colors.darkGray },
    h: 5.28,
    w: 5.84,
    x: 6.8,
    y: 1.11,
  }),
  lciBoxRectangle({
    fill: { color: theme.colors.darkBlue },
    h: 0.94,
    w: 4.85,
    x: 7.36,
    y: 2.76,
  }),
  lciBoxRectangle({
    fill: { color: theme.colors.blue },
    h: 0.98,
    w: 4.85,
    x: 7.36,
    y: 3.75,
  }),
  lciBoxRectangle({
    fill: { color: theme.colors.white },
    h: 0.91,
    w: 4.85,
    x: 7.36,
    y: 4.78,
  }),
  lciBoxImageOutline({
    y: 2.92,
  }),
  lciBoxImageOutline({
    y: 3.96,
  }),
  lciBoxImageOutline({
    y: 4.9,
  }),
];
